export const subscriptionTableColumns = [
    {
        Header: "#",
        accessor: "index",
        Cell: ({ row }) => row.index + 1,
    },
    {
        Header: "Subscription Name",
        accessor: "name",
    },
    {
        Header: "Description",
        accessor: "planDescription",
    },
    {
        Header: "Setup Fee ($)",
        accessor: "setupFee",
        Cell: ({ value }) => (
            <div style={{ textAlign: "right" }}>
                {typeof value === "number" ? `$${value.toFixed(2)}` : "-"}
            </div>
        ),
    },
    {
        Header: "Monthly Fee ($)",
        accessor: "monthlyFee",
        Cell: ({ value }) => (
            <div style={{ textAlign: "right" }}>
                {typeof value === "number" ? `$${value.toFixed(2)}` : "-"}
            </div>
        ),
    },
    {
        Header: "Cancel Fee ($)",
        accessor: "cancelFee",
        Cell: ({ value }) => (
            <div style={{ textAlign: "right" }}>
                {typeof value === "number" ? `$${value.toFixed(2)}` : "-"}
            </div>
        ),
    },
    {
        Header: "Created At",
        accessor: "createdAt",
        Cell: ({ value }) => <div style={{ textAlign: "center" }}>{value || "-"}</div>,
    },
];
